import { CustomerCodes } from "./AgencyMasterProperties";
import { AgencyRightsProperties } from "./AgencyRightsProperties";
import { ManagerProperties } from "./ManagerProperties";
import { AgencySupplierRightsProperties } from "./SuppliersProperties";
import { UsersProperties } from "./UsersProperties";

export class BranchInformationProperties {
  branchId: string = "";
  branchName: string = "";
  status: boolean = false;
  branchEmail: string = "";
  notificationEmail: string = "";
  address: string = "";
  country: string = "";
  city: string = "";
  zip: string = "";
  currencyId: number = 0;
  languageId: number = 0;
  mobile: string = "";
  telephone: string = "";
  fax: string = "";
  maxUsers: number ;
  maximumChildAgencies: number=0 ;
  maximumChildBranches: number=0 ;
  managerName: string = "";
  managerEmail: string = "";
  managerUserId: number = 0;
  managerPhone: string = "";
  settlementMode: number = 0;
  creditLimit: number = 0;
  creationDateTime: string = ""
  creationUser: number = 0;
  modifyDateTime: string = "";
  modifyUser: number = 0;
  immediateParent: string = "";
  agencyId: string = "";
  isAgencyParent: boolean = false;
  branchLevel: number = 0;
  backSystemBranchId: string = "";
  userObj = new UsersProperties();
  agencyRightObj = new AgencyRightsProperties();
  agencySupplierList: AgencySupplierRightsProperties[] = [];
  pendingcreditLimit: number = 0;
  managers: ManagerProperties[] = [];
  isAlreadyActive: boolean = false;
  backCompanyId: number = 0;
  logoFilePath: string="";
  logoFileName: string = "";
  imageFile: string = "";
    branchColourCode: string="";
  
  
}
export class branchBackFromServerProperties {
  branchId: string;
  message: string;
  isSave: boolean;
  managers: ManagerProperties[] = [];
}
export class BackSystemOfficeProperties {
  bk_AgencyBranchID: number=0;
  backSystemCompanyId: number;
  backSystemCompanyCustomer: string[] = [];
  agecnyBranchID: string = "";
  userID: number;
  customerCodesList:CustomerCodes[]=[];
  selectSingleBackSystemCustomer:string="";
  agecnyBranchIDParent:string="";
}
export class BackSystemCompanyRecord {
  backSystemCompanyId: number;
  agecnyBranchID: string = "";
}
export class BackSystemAll {
  backSystemBK_AgencyBranchID: number;
  backSystemCompanyCustomer: string = "";
}
export class BackSystemAllList {
  backSystemCompanyId: number ;
  agecnyBranchID: string = "";
  backSystemAll: BackSystemAll[] = []

}
export class BackSystemCompanyId {
  backSystemCompanyId: number;

}
export class ParentBackSystemCompanies {
  backSystemCompanyId: number;
  backSystemCustomerCode: string ;

}

